export const REACT_APP_MIDDLEWARE_ENDPOINT = process.env.REACT_APP_MIDDLEWARE_ENDPOINT || '__REACT_APP_MIDDLEWARE_ENDPOINT__';
export const REACT_APP_OAUTH_CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID || '__REACT_APP_OAUTH_CLIENT_ID__';
export const REACT_APP_OAUTH_CLIENT_SCOPES = process.env.REACT_APP_OAUTH_CLIENT_SCOPES || '__REACT_APP_OAUTH_CLIENT_SCOPES__';
